import React from 'react';

export class SearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { searchQuery: '' };

        this.handleSearchQueryChange = this.handleSearchQueryChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLuckyClick = this.handleLuckyClick.bind(this);
    }

    handleSearchQueryChange(e) {
        this.setState({ searchQuery: e.target.value });
    }

    handleSubmit(e) {
        e.preventDefault();
        let searchQuery = this.state.searchQuery.trim();

        if (!searchQuery) {
            return;
        }

        this.props.onSearchSubmit({ searchQuery: searchQuery });

    }

    handleLuckyClick(e) {
        let searchQuery = this.state.searchQuery.trim();

        if (!searchQuery) {
            return;
        }

        this.props.onLuckyClick({ searchQuery: searchQuery });
    }

    render() {
        return (
            <form className="searchForm" role="form" onSubmit={this.handleSubmit}>
                <div className="row margin-bottom-20">
                    <div className="col-md-6 col-md-offset-3">
                        <div className="form-group-lg has-feedback">
                            <input ref="txtSearch" autoFocus type="text"
                                   value={this.state.searchQuery} onChange={this.handleSearchQueryChange}
                                   className="form-control input-lg" placeholder="Introduzca su b&uacute;squeda" />
                            <span className="form-control-feedback glyphicon glyphicon-search" style={{color: '#2F74AD'}}/>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 text-center">
                        <input type="submit" value="Buscar!" className="btn btn-primary"
                               disabled={this.props.disabled}/>
                        &nbsp;
                        <input type="button" value="Voy a tener suerte" className="btn btn-default"
                               disabled={this.props.disabled} onClick={this.handleLuckyClick} />
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ../containers/SearchForm/SearchForm.jsx